import { useEffect, useRef } from 'react';
import {
  collectBlobObjectUrls,
  createDisplayObjectUrlOwner,
  type DisplayObjectUrlOwner,
} from '../lib/productImages/objectUrls';

/**
 * Consumer-owned blob: URL lifecycle.
 * Retains URLs while mounted; releases (and revokes at refcount 0) on unmount
 * or when the URL set is replaced.
 */
export function useRevokeObjectUrls(
  urls: Iterable<string | null | undefined>,
): void {
  const ownerRef = useRef<DisplayObjectUrlOwner | null>(null);
  if (!ownerRef.current) ownerRef.current = createDisplayObjectUrlOwner();
  const owner = ownerRef.current;
  const next = collectBlobObjectUrls(urls).sort();
  // Stable dependency: sorted unique blob URLs.
  const key = next.join('\0');

  useEffect(() => {
    owner.replace(next);
  }, [key, owner]);

  useEffect(() => {
    return () => {
      owner.releaseAll();
    };
  }, [owner]);
}
